import { Button } from '@hivebrite/design-system/Button';

export const ButtonNext = ({
  isFixed,
  withBillingStepWorkflow,
  isShippable,
  isLoading,
}) => {
  if (isFixed) {
    return (
      <Button
        dataTestId="ticket-information-step-next"
        isLoading={isLoading}
        type="submit"
      >
        {s__('NetworkEvents|Next')}
      </Button>
    );
  }

  if (withBillingStepWorkflow) {
    return (
      <Button
        dataTestId="ticket-information-step-proceed"
        isLoading={isLoading}
        type="submit"
      >
        {s__('NetworkEvents|Proceed to Billing Information')}
      </Button>
    );
  }

  if (isShippable) {
    return (
      <Button
        dataTestId="ticket-information-step-submit"
        isLoading={isLoading}
        type="submit"
      >
        {s__('NetworkEvents|Proceed to Shipping Information')}
      </Button>
    );
  }

  return (
    <Button
      dataTestId="ticket-information-step-submit"
      isLoading={isLoading}
      type="submit"
    >
      {s__('NetworkEvents|Submit')}
    </Button>
  );
};
